import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  Button,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { ContratadoRequisicaoCompraServico } from '@app/api/projeto';

interface FormResumoContratadoProps {
  contratadoRequisicaoCompraServico: ContratadoRequisicaoCompraServico[];
  style: any;
}

const { Panel } = Collapse;

const FormTableContratadoRequisicaoCompraServico = (props: FormResumoContratadoProps) => {
  const { contratadoRequisicaoCompraServico, style } = props;

  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (contratadoRequisicaoCompraServico.length > 0) {
        var requisitado = contratadoRequisicaoCompraServico[contratadoRequisicaoCompraServico.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.distribuidoTotalFormatado);
        }
      } else {
        setValorTotal('');
      }
    };

    getData();
  }, [contratadoRequisicaoCompraServico]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'RC',
        dataIndex: 'contratadoCompraNumero',
        width: '2%',
      },
      {
        title: 'RC Seq',
        dataIndex: 'contratadoCompraSeq',
        width: '13%',
      },
      {
        title: 'Narrativa',
        dataIndex: 'narrativa',
        width: '35%',
      },
      // {
      //   title: 'Valor total',
      //   dataIndex: 'requisicaoCompraValorTotalFormatado',
      //   width: '35%',
      // },
      {
        title: 'No Projeto',
        dataIndex: 'valorDistribuidoFormatado',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorDistribuidoFormatado',
            width: '25%',
          },
        ],
      },
      // {
      //   title: 'Valor à distribuir',
      //   dataIndex: 'valorParaDistribuidoFormatado',
      //   width: '35%',
      // },
      {
        title: 'OC',
        dataIndex: 'contratadoCompraOc',
        width: '25%',
      },
      {
        title: 'PCM',
        dataIndex: 'pedidoPcm',
        width: '25%',
      },
      {
        title: 'CT/PCS',
        dataIndex: 'pedidoCtPcs',
        width: '25%',
      },
    ] as InlineEditColumnProps<ContratadoRequisicaoCompraServico>[];
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="ITENS DE REQUISIÇÃO DE COMPRA DE SERVIÇO (CONTRATO/PCS)" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                <Button
                  title="Distribuir contratado serviço"
                  type="primary"
                  icon="commons-search"
                  onClick={() => {
                    window.location.href = `/Cr/moduloContratado/pedidoServico`;
                  }}
                />,
              ]}>
              <Row>
                <Table
                  rowKey="index"
                  columns={customColumns()}
                  dataSource={contratadoRequisicaoCompraServico}
                  pagination={
                    {
                      pageSize: 5,
                    }
                  }
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableContratadoRequisicaoCompraServico;
